import * as React from "react";

export function useEffectAsync(fn: () => Promise<void>, deps?: any[]) {
    React.useEffect(() => {
        fn().catch((err) => {
            console.error("useEffectAsync function failed with error", { err });
        });
    }, deps);
}
